import { render, staticRenderFns } from "./stock-ledger.vue?vue&type=template&id=64be4d64&"
import script from "./stock-ledger.vue?vue&type=script&lang=js&"
export * from "./stock-ledger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports